import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/3fd5cee58d131fe08dd51dfa0135fe96/757afedbc117cab9bd9037c1de933f02.png" 
                alt="Novacréditos Logo" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Institución financiera regulada comprometida con la transparencia y el crecimiento de nuestros clientes desde 2009.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6">Servicios</h3>
            <ul className="space-y-3">
              <li><Link to="/servicios" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Crédito Empresarial</Link></li>
              <li><Link to="/servicios" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Crédito Personal</Link></li>
              <li><Link to="/servicios" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Microcréditos</Link></li>
              <li><Link to="/servicios" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Crédito Hipotecario</Link></li>
              <li><Link to="/servicios" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Refinanciamiento</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6">Empresa</h3>
            <ul className="space-y-3">
              <li><Link to="/quienes-somos" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Quiénes Somos</Link></li>
              <li><Link to="/paises" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Países</Link></li>
              <li><Link to="/contacto" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Contacto</Link></li>
              <li><Link to="/aviso-privacidad" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Aviso de Privacidad</Link></li>
              <li><Link to="/terminos-condiciones" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Términos y Condiciones</Link></li>
              <li><Link to="/cumplimiento-legal" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">Cumplimiento Legal</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-emerald-400 text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm text-slate-400">Chile: +56 2 2345 6789</p>
                  <p className="text-sm text-slate-400">Perú: +51 1 234 5678</p>
                  <p className="text-sm text-slate-400">México: +52 55 1234 5678</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-emerald-400 text-lg mt-0.5"></i>
                <a href="mailto:creditfacilpanama@gmail.com" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
                  creditfacilpanama@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-whatsapp-line text-emerald-400 text-lg mt-0.5"></i>
                <a 
                  href="https://wa.me/447481624940?text=Hola%20Novacréditos,%20deseo%20información%20confidencial%20sobre%20sus%20servicios%20de%20crédito."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors cursor-pointer"
                >
                  +44 7481 624940
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-xs">
              © 2025 Novacréditos. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <Link to="/aviso-privacidad" className="text-slate-400 hover:text-emerald-400 transition-colors text-xs">
                Aviso de Privacidad
              </Link>
              <Link to="/terminos-condiciones" className="text-slate-400 hover:text-emerald-400 transition-colors text-xs">
                Términos y Condiciones
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-emerald-400 transition-colors text-xs">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
